import React from 'react';

export const AppFooter = () => {
    return (
        <div className="layout-footer">
		    <span className="footer-text" style={{'marginRight': '5px'}}>SEPLAG - STI - Coordenadoria de Sistemas</span>
        </div>
    );
}
